module.exports = __webpack_public_path__ + "static/img/bill.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/bill.jpg
// module id = +uuU
// module chunks = 0